export var DICCIONARIO = {
    custom: {
        "data.name": {
            required: 'The name field is required.'
        },
        "data.company_name": {
            required: 'The company name field is required.'
        },
        "data.email": {
            required: 'The email field is required.'
        },
        "data.billing_data": {
            required: 'The billing data field is required.'
        },
        "data.vat": {
            required: 'The vat field is required.'
        },
        "data.country": {
            required: 'The country field is required.'
        },
        "data.state": {
            required: 'The state field is required.'
        },
        "data.shipping_address": {
            required: 'The shipping address field is required.'
        },
        "data.to": {
            required: 'The to field is required.'
        },
        "data.date": {
            required: 'The date field is required.'
        },
        "data.customer_code": {
            required: 'The customer code field is required.'
        },
        "data.our_order_number": {
            required: 'The our order number field is required.'
        },
        "data.client_order_number": {
            required: 'The client order number field is required.'
        },"data.delivery_terms": {
            required: 'The delivery terms field is required.'
        },
        "data.to_2": {
            required: 'The to field is required.'
        },
        "data.payment_terms": {
            required: 'The payment terms field is required.'
        },
        "data.currency": {
            required: 'The currency field is required.'
        },
        "data.concept": {
            required: 'The concept field is required.'
        },
        "data.code": {
            required: 'The code field is required.'
        },
        "data.product_description": {
            required: 'The product description field is required.'
        },
        "data.sample_ref": {
            required: 'The sample reference field is required.'
        },
        "data.request_": {
            required: 'The sample request field is required.'
        },
        "data.contact_person": {
            required: 'The contact person field is required.'
        },
        "data.account_manager": {
            required: 'The account manager field is required.'
        },
        "data.customer_courier_number": {
            required: 'The customer courier number field is required.'
        },
        "data.final_client": {
            required: 'The final client field is required.'
        },
        "data.reference": {
            required: 'The lc code field is required.'
        },
        "data.ftn_code": {
            required: 'The supplier code field is required.'
        },
        "data.quantity": {
            required: 'The quantity field is required.'
        },
        "data.enter_parameters": {
            required: 'The enter parameters field is required.'
        },
        "data.fruit_content": {
            required: 'The fruit contet field is required.'
        },
        "data.sample_priority_id": {
            required: 'The priority field is required.'
        },
        "data.sample_application_id": {
            required: 'The application field is required.'
        },
        "data.sample_type_of_project_id": {
            required: 'The type of project field is required.'
        },
        "data.target_price": {
            required: 'The target price field is required.'
        },
        "data.project_potential_volume": {
            required: 'The project potential volume field is required.'
        },
        "data.notes": {
            required: 'The notes field is required.'
        },
    }
};


// WEBPACK FOOTER //
// ./src/diccionario.js